<script lang="ts">
    
    import { createEventDispatcher, onMount } from "svelte";
    import { boardsService, gamesService, playerService } from "../../Services";
    import { i18n } from "../../Services/i18n";
    import LangIconsSelect from "../Shared/LangIconsSelect.svelte";
    import { useLocation } from "svelte-navigator";

    const location = useLocation();

    export let gameId: string = '';
    export let roomId: string = '';

    const dispatch = createEventDispatcher();

    let isSubmiting = false;
    export let gameCode = '';
    let getBoardFail = false;
    const isRegistered = playerService.isRegistered

    onMount(async () => {
        const query = new URLSearchParams($location.search);
        if (query.has('gameCode')) {
                if(await gamesService.checkIfCodeIsInUse(query.get('gameCode'))){
                    gameCode = query.get('gameCode');
                } else {
                    gameCode = '';
                }
        }
    })

    async function onSubmit(): Promise<void> {
        if (isSubmiting) {
            return;
        }
        isSubmiting = true;
        try {
            isSubmiting = true;
            if($isRegistered) {
                await boardsService.createBoard(roomId, gameId, `${gameCode}`.padStart(4, '0'));
            }   
            dispatch('submited')
        } catch (error) {
            console.error(error);
            getBoardFail = true;
        } finally {
            isSubmiting = false;
        }
    }

    function onAnimationend(): void {
        getBoardFail = false;
    }

</script>

<form class="get-board-form" on:submit|preventDefault={onSubmit}>
    <div class="content">
        <p class="instructions">
            {$i18n("Introduzca el código de juego")}
        </p>
        <div class="code-group">
            <input class="game-code-input" type="number" bind:value={gameCode} class:fail={getBoardFail} disabled={isSubmiting} on:animationend={onAnimationend}>
            <button class="enter-btn" type="submit" disabled={isSubmiting}>
                {$i18n('Entrar')}
            </button>
        </div>
    </div>
</form>

<div style="margin-top: 3rem; display: flex; justify-content: center;">
    <LangIconsSelect />
</div>

<style lang="scss">

    .game-code-input {
        text-align: center;
    }

    .get-board-form {
        display: flex;
        justify-content: center;
    }

    .instructions {
        text-align: center;
        padding: 0 1rem;
        font-size: 1.2rem;
    }

    .content {
        padding: 0 1rem;
        max-width: 400px;
        width: 100%;
        box-sizing: border-box;
    }

    .code-group {
        display: flex;
        justify-content: center;
    }

    .game-code-input {
        flex: 1 1 0;
        min-width: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .enter-btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .fail {
        border: solid red 2px;
        animation: shake 0.5s 1;
    }

</style>
